import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=75417982"
import script from "./Textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75417982')) {
      api.createRecord('75417982', component.options)
    } else {
      api.reload('75417982', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=75417982", function () {
      api.rerender('75417982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/forms/Textarea.vue"
export default component.exports